// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sid-request-report th{font-weight:normal}.sid-request-report td{white-space:nowrap}.sid-request-report .legend-color-box{display:inline-block;width:16px;height:16px;border-radius:50%;margin-right:4px;vertical-align:baseline;vertical-align:initial}.sid * cbp-loading-spinner>div{display:inline-block}", ""]);
// Exports
module.exports = exports;
